import React from "react";
import SidePanel from "..";
import t from "../../../../../../i18n";
import type { EditableQuantity } from "../../view/Quantities/useMetadata";
import type { EditQuantityHandle } from "../../EditQuantity/EditQuantity";
import EditQuantity from "../../EditQuantity/EditQuantity";
import { useQuantityFormulaVersions } from "../../../../../../api/quantity/formula-version";

interface Props {
  projectId: string;
  timezone: string;
  isFolded: boolean;
  closePanel: () => void;
  quantity: EditableQuantity;

  focusFormulaeView?: boolean;
}

const EditFormulaQuantitySidePanel = ({
  projectId,
  timezone,
  isFolded,
  closePanel,
  quantity,
  focusFormulaeView,
}: Props) => {
  const editQuantityRef = React.useRef<EditQuantityHandle>(null);
  const [quantityName, setQuantityName] = React.useState(quantity.name);
  const resetFormAndclosePanel = () => {
    editQuantityRef.current?.resetForm();
    closePanel();
  };
  const quantityFormulaVersions = useQuantityFormulaVersions(projectId, quantity.id);

  React.useEffect(() => {
    setQuantityName(quantity.name);
  }, [quantity.name]);

  return (
    <SidePanel
      title={t("project.settings.quantity.side_panel.edit.title")}
      subtitle={quantityName}
      closeHandler={resetFormAndclosePanel}
      isFolded={isFolded}
      focusedView={focusFormulaeView ? "formulae" : undefined}
      hasFormula={quantity.type === "FORMULA"}
      formulaCount={quantity.type === "FORMULA" ? 1 + quantityFormulaVersions.length : undefined}
    >
      {sidePanelView => (
        <EditQuantity
          timezone={timezone}
          view={sidePanelView}
          ref={editQuantityRef}
          projectId={projectId}
          quantity={quantity}
          closePanel={resetFormAndclosePanel}
          onNameChange={setQuantityName}
        />
      )}
    </SidePanel>
  );
};

export default EditFormulaQuantitySidePanel;
